import { NP_METRIC_CONFIG } from '@netpurpose/types'
import type { User as BEUser } from '../../generated/users'
import { type Camelize, snakeToCamelKeys } from '../../utils'

const transformUser = <UserProps extends Camelize<BEUser>>({
  firstName,
  lastName,
  displayName,
  userPersona,
  defaultMetricsConfigId,
  active,
  lastLogin,
  ...rest
}: UserProps) => ({
  firstName: firstName ?? '',
  lastName: lastName ?? '',
  // NOTE: this is needed for filtering to work on users & group users tables
  combinedName: `${firstName ?? ''} ${lastName ?? ''}`,
  displayName: displayName ?? '',
  userPersona: userPersona ?? undefined,
  defaultMetricsConfigId: defaultMetricsConfigId ?? NP_METRIC_CONFIG,
  active: active ?? false,
  lastLogin: lastLogin ? new Date(lastLogin) : null,
  ...rest,
})

export const transformUserWithPermissions = (data: BEUser) => ({
  ...transformUser(snakeToCamelKeys(data)),
  // NOTE: we don't want to camelize permissions
  permissions: data?.permissions || undefined,
  groups: (data?.groups || []).map((group) => ({
    ...snakeToCamelKeys(group),
    name: group.name || '',
    permissions: group?.permissions || undefined,
  })),
})

export type UserInfo = ReturnType<typeof transformUserWithPermissions>
